// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.date-filter-form-summary {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 25px 20px;
  margin: 20px auto; 
  gap: 20px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 8px; 
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.senderid-date-field {
  display: flex;
  flex-direction: column;
  width: 25%
}

.senderid-date-field label {
  font-weight: bold;
  margin-bottom: 8px;
  text-align: left;
}

.senderid-date-field input {
  padding: 10px 5px;
  font-size: 16px;
  border: 1px solid #f2f2f2;
}

.senderid-form-actions {
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 15px 0 0;
}

.senderid-form-actions .btn {
  padding: 8px 16px;
  font-size: 16px;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
}

.senderid-form-actions .submit-btn {
  background-color: #44a67e;
  border-color: #44a67e;
}

.senderid-form-actions .submit-btn:hover {
  background-color: #44a67e;
  border-color: #44a67e;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
}

.senderid-form-actions .download-btn {
  background: #373435;
  color: #ffcc29;
}

.senderid-form-actions .download-btn:hover {
  background: #373435;
  color: #ffcc29;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
}

/* Responsive Styles */
@media (max-width: 700px) {
  .date-filter-form-summary {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }

  .senderid-date-field input {
    max-width: 100%;
  }

  .senderid-form-actions {
    flex-direction: column;
    width: 100%;
  }

  .senderid-form-actions .btn {
    width: 100%;
    text-align: center;
  }
}


/* Ensure Table is Scrollable on Small Screens */
.senderid-table-container {
  width: 100%;
  overflow-x: auto;
  margin-top: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  background: #fff;
}

.senderid-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}

.senderid-table th,
.senderid-table td {
  padding: 12px 15px;
  border: 1px solid #ddd;
  font-size: 14px;
}

.senderid-table th {
  background-color: #f4f4f4;
  color: #373435;
  font-weight: 600;
  text-transform: uppercase;
  text-align: left;
}

.senderid-table tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

.senderid-table tbody tr:hover {
  background-color:  rgba(255, 204, 41, 0.2);
}

.senderid-table td {
  color: #373435;
}

.senderid-table tbody tr:last-child td {
  border-bottom: 2px solid #ffcc29;
}

/* Expand Button */
.senderid-expand-btn {
  background: #373435;
  color: #ffcc29;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  border-radius: 4px;
  font-size: 16px;
}

.senderid-expand-btn:hover {
  background: #ffcc29;
  color: #373435;
}

/* Expanded Row */
.senderid-expanded-row {
  background-color: #eef7ff;
}

.senderid-expanded-content {
  padding: 10px;
}

.table-entries {
  text-align: left;
}

@media screen and (max-width: 1050px) {
  .under-1000px {
    display: none;
  }
}

@media screen and (min-width: 1051px) {
  .toggle-button-expansion {
    display: none;
  }
}

/* Make Table Rows Stack on Small Screens */
@media screen and (max-width: 768px) {
  .date-filter-form-summary {
      flex-direction: column;
      align-items: flex-start;
  }

  .senderid-date-field {
      width: 100%;
      align-items: center;
  }

  .senderid-form-actions {
      flex-direction: column;
      width: 100%;
  }

  .senderid-form-actions .btn {
      width: 100%;
  }

  .senderid-table-container {
    overflow-x: auto;
  }
}


/* ============================================================================================= */
  
  /* Loader Style */
  .loader-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }
  
  .loader {
    border: 4px solid #f3f3f3;
    border-top: 4px solid #373435;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
  .loader-overlay p {
    margin-top: 10px;
    font-size: 1rem;
    color: #333;
  }

  /* search filter */
  .senderid-search-filter {
    margin: 20px auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: end;
    align-items: center;
    gap: 20px;
  }
  
  .senderid-search-filter input {
    width: 250px;
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
  }
  

/* Pagination style */
.pagination-footer {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

@media (max-width: 900px) {
  .pagination-footer {
    flex-direction: column;
    align-items: center;
  }
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.pagination button {
  margin: 5px;
  padding: 5px 10px;
  border: 1px solid #ddd;
  background-color: white;
  cursor: pointer;
}

.pagination button.active {
  background-color: #ffcc29;
  color: #373435;
}

.pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}


.wrap-senderid-report {
  margin: 0 40px;
}`, "",{"version":3,"sources":["webpack://./src/components/SenderIdReport/SenderIdReport.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,qFAAqF;AACvF;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qFAAqF;AACvF;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF;;;AAGA,gDAAgD;AAChD;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,2CAA2C;AAC3C;EACE;MACI,sBAAsB;MACtB,uBAAuB;EAC3B;;EAEA;MACI,WAAW;MACX,mBAAmB;EACvB;;EAEA;MACI,sBAAsB;MACtB,WAAW;EACf;;EAEA;MACI,WAAW;EACf;;EAEA;IACE,gBAAgB;EAClB;AACF;;;AAGA,kGAAkG;;EAEhG,iBAAiB;EACjB;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,0CAA0C;IAC1C,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;EACpC;;EAEA;IACE,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;EACpC;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,WAAW;EACb;;EAEA,kBAAkB;EAClB;IACE,iBAAiB;IACjB,aAAa;IACb,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;;;AAGF,qBAAqB;AACrB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;;AAGA;EACE,cAAc;AAChB","sourcesContent":[".date-filter-form-summary {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 25px 20px;\r\n  margin: 20px auto; \r\n  gap: 20px;\r\n  background-color: #fff;\r\n  border: 1px solid #ddd;\r\n  border-radius: 8px; \r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.senderid-date-field {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 25%\r\n}\r\n\r\n.senderid-date-field label {\r\n  font-weight: bold;\r\n  margin-bottom: 8px;\r\n  text-align: left;\r\n}\r\n\r\n.senderid-date-field input {\r\n  padding: 10px 5px;\r\n  font-size: 16px;\r\n  border: 1px solid #f2f2f2;\r\n}\r\n\r\n.senderid-form-actions {\r\n  display: flex;\r\n  gap: 10px;\r\n  align-items: center;\r\n  padding: 15px 0 0;\r\n}\r\n\r\n.senderid-form-actions .btn {\r\n  padding: 8px 16px;\r\n  font-size: 16px;\r\n  color: #fff;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n\r\n.senderid-form-actions .submit-btn {\r\n  background-color: #44a67e;\r\n  border-color: #44a67e;\r\n}\r\n\r\n.senderid-form-actions .submit-btn:hover {\r\n  background-color: #44a67e;\r\n  border-color: #44a67e;\r\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;\r\n}\r\n\r\n.senderid-form-actions .download-btn {\r\n  background: #373435;\r\n  color: #ffcc29;\r\n}\r\n\r\n.senderid-form-actions .download-btn:hover {\r\n  background: #373435;\r\n  color: #ffcc29;\r\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;\r\n}\r\n\r\n/* Responsive Styles */\r\n@media (max-width: 700px) {\r\n  .date-filter-form-summary {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 15px;\r\n  }\r\n\r\n  .senderid-date-field input {\r\n    max-width: 100%;\r\n  }\r\n\r\n  .senderid-form-actions {\r\n    flex-direction: column;\r\n    width: 100%;\r\n  }\r\n\r\n  .senderid-form-actions .btn {\r\n    width: 100%;\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n\r\n/* Ensure Table is Scrollable on Small Screens */\r\n.senderid-table-container {\r\n  width: 100%;\r\n  overflow-x: auto;\r\n  margin-top: 20px;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n  background: #fff;\r\n}\r\n\r\n.senderid-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  text-align: left;\r\n}\r\n\r\n.senderid-table th,\r\n.senderid-table td {\r\n  padding: 12px 15px;\r\n  border: 1px solid #ddd;\r\n  font-size: 14px;\r\n}\r\n\r\n.senderid-table th {\r\n  background-color: #f4f4f4;\r\n  color: #373435;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  text-align: left;\r\n}\r\n\r\n.senderid-table tbody tr:nth-child(even) {\r\n  background-color: #f9f9f9;\r\n}\r\n\r\n.senderid-table tbody tr:hover {\r\n  background-color:  rgba(255, 204, 41, 0.2);\r\n}\r\n\r\n.senderid-table td {\r\n  color: #373435;\r\n}\r\n\r\n.senderid-table tbody tr:last-child td {\r\n  border-bottom: 2px solid #ffcc29;\r\n}\r\n\r\n/* Expand Button */\r\n.senderid-expand-btn {\r\n  background: #373435;\r\n  color: #ffcc29;\r\n  border: none;\r\n  padding: 5px 10px;\r\n  cursor: pointer;\r\n  border-radius: 4px;\r\n  font-size: 16px;\r\n}\r\n\r\n.senderid-expand-btn:hover {\r\n  background: #ffcc29;\r\n  color: #373435;\r\n}\r\n\r\n/* Expanded Row */\r\n.senderid-expanded-row {\r\n  background-color: #eef7ff;\r\n}\r\n\r\n.senderid-expanded-content {\r\n  padding: 10px;\r\n}\r\n\r\n.table-entries {\r\n  text-align: left;\r\n}\r\n\r\n@media screen and (max-width: 1050px) {\r\n  .under-1000px {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 1051px) {\r\n  .toggle-button-expansion {\r\n    display: none;\r\n  }\r\n}\r\n\r\n/* Make Table Rows Stack on Small Screens */\r\n@media screen and (max-width: 768px) {\r\n  .date-filter-form-summary {\r\n      flex-direction: column;\r\n      align-items: flex-start;\r\n  }\r\n\r\n  .senderid-date-field {\r\n      width: 100%;\r\n      align-items: center;\r\n  }\r\n\r\n  .senderid-form-actions {\r\n      flex-direction: column;\r\n      width: 100%;\r\n  }\r\n\r\n  .senderid-form-actions .btn {\r\n      width: 100%;\r\n  }\r\n\r\n  .senderid-table-container {\r\n    overflow-x: auto;\r\n  }\r\n}\r\n\r\n\r\n/* ============================================================================================= */\r\n  \r\n  /* Loader Style */\r\n  .loader-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: rgba(255, 255, 255, 0.8);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 9999;\r\n  }\r\n  \r\n  .loader {\r\n    border: 4px solid #f3f3f3;\r\n    border-top: 4px solid #373435;\r\n    border-radius: 50%;\r\n    width: 40px;\r\n    height: 40px;\r\n    animation: spin 1s linear infinite;\r\n  }\r\n  \r\n  @keyframes spin {\r\n    0% { transform: rotate(0deg); }\r\n    100% { transform: rotate(360deg); }\r\n  }\r\n  \r\n  .loader-overlay p {\r\n    margin-top: 10px;\r\n    font-size: 1rem;\r\n    color: #333;\r\n  }\r\n\r\n  /* search filter */\r\n  .senderid-search-filter {\r\n    margin: 20px auto;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    justify-content: end;\r\n    align-items: center;\r\n    gap: 20px;\r\n  }\r\n  \r\n  .senderid-search-filter input {\r\n    width: 250px;\r\n    padding: 12px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    font-size: 14px;\r\n  }\r\n  \r\n\r\n/* Pagination style */\r\n.pagination-footer {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n@media (max-width: 900px) {\r\n  .pagination-footer {\r\n    flex-direction: column;\r\n    align-items: center;\r\n  }\r\n}\r\n\r\n.pagination {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin-top: 10px;\r\n}\r\n\r\n.pagination button {\r\n  margin: 5px;\r\n  padding: 5px 10px;\r\n  border: 1px solid #ddd;\r\n  background-color: white;\r\n  cursor: pointer;\r\n}\r\n\r\n.pagination button.active {\r\n  background-color: #ffcc29;\r\n  color: #373435;\r\n}\r\n\r\n.pagination button:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n\r\n.wrap-senderid-report {\r\n  margin: 0 40px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
